import { render, staticRenderFns } from "./LandingSpidPage.vue?vue&type=template&id=ded3343c&"
import script from "./LandingSpidPage.vue?vue&type=script&lang=js&"
export * from "./LandingSpidPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LandingSpidPage.vue"
export default component.exports